// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionC_TheComp__TSvLz"};